/**
 * API Configuration
 * Centralized API base URL configuration
 *
 * Vite mode loading:
 * - `npm run dev` → `.env.development`
 * - `npm run build` / `vite --mode production` → `.env`
 *
 * Set `VITE_API_BASE_URL` in the mode-specific file if needed.
 */

function defaultApiBaseUrl(): string {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }
  // Same-origin /backend-api: Vite dev proxy → Uvicorn (xem VITE_API_PROXY_TARGET);
  // prod: nginx proxy. Hoạt động với mọi hostname (localhost, IP LAN, domain public).
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/backend-api`
  }
  return 'http://localhost:8000/backend-api'
}

let apiBaseUrl = defaultApiBaseUrl()

// Remove trailing slash to avoid double slashes
apiBaseUrl = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl

// Force HTTPS if page is loaded via HTTPS
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && apiBaseUrl.startsWith('http://')) {
  apiBaseUrl = apiBaseUrl.replace('http://', 'https://')
  console.warn('⚠️ API URL was http://, forced to https:// to avoid mixed-content error')
}

export const API_BASE_URL = apiBaseUrl

// Log for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('🌐 API Base URL:', API_BASE_URL)
}
